import React from 'react';

const toId = value => String(value);

const QuestionPalette = ({
  questions,
  markedbackup,
  savedbackup,
  visitedbackup,
  currentQuestionIndex,
  onQuestionSelect,
  mobile = false,
}) => {
  const markedIds = new Set((markedbackup || []).map(item => toId(item.q_id)));
  const savedIds = new Set((savedbackup || []).map(item => toId(item.q_id)));
  const visitedIds = new Set((visitedbackup || []).map(item => toId(item.q_id)));

  return (
    <div className={`question-palette ${mobile ? 'question-palette--mobile' : ''}`}>
      {(questions || []).map((item, index) => {
        const id = toId(item.q_id);
        const isCurrent = index === currentQuestionIndex;
        const isSaved = savedIds.has(id);
        const isMarked = markedIds.has(id);
        const isVisited = visitedIds.has(id);

        let status = 'not-visited';
        if (isSaved) status = 'answered';
        else if (isMarked) status = 'marked';
        else if (isVisited) status = 'visited';

        return (
          <button
            type="button"
            key={item.q_id || index}
            className={`question-number-button question-number-button--${status} ${isCurrent ? 'question-number-button--current' : ''}`}
            onClick={() => onQuestionSelect(index)}
            aria-label={`Question ${index + 1}`}
            aria-current={isCurrent ? 'true' : undefined}
          >
            {index + 1}
          </button>
        );
      })}
    </div>
  );
};

export default QuestionPalette;
